import { emptySplitApi } from "./index";

export const sectorCAApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getSectorListCA: builder.query({
            query: () => ({
                url: `api/v1/search-engine-ca-service/sector`,
                method: "GET",
            }),
        }),
        getSectorListCA2: builder.query({
            query: () => ({
                url: `api/v1/search-engine-ca-service/sector`,
                method: "GET",
            }),
            transformResponse: (response) => response.map((item) => ({
                id: item.id,
                label: item.sectorName,
                value: item.sectorName,
            })),
        }),
        getSubSectorListBySectorNamesCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/sector/sub-sector`,
                method: "POST",
                body: model,
            }),
        }),
        getDonationsSubSectorListBySectorNamesCA: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/sector/donations-sub-sector`,
                method: "POST",
                body: model,
            }),
        }),
        getDonationsSubSectorListBySectorNamesCA2: builder.query({
            query: (model) => ({
                url: `api/v1/search-engine-ca-service/sector/donations-sub-sector`,
                method: "POST",
                body: model,
            }),
            transformResponse: (response) => response.map((item) => ({
                id: item.id,
                label: item.subSectorName,
                value: item.subSectorName,
                secondaryLabel: item.sectorName,
            })),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetSectorListCAQuery,
    useGetSectorListCA2Query,
    useGetSubSectorListBySectorNamesCAMutation,
    useGetDonationsSubSectorListBySectorNamesCAMutation,
    useGetDonationsSubSectorListBySectorNamesCA2Query,
} = sectorCAApi;
